
import React, { useCallback, useContext, useState } from "react";
import { IconButton, InputAdornment, TextField, Tooltip, Typography } from "@mui/material";
import CheckRounded from '@mui/icons-material/CheckRounded';
import { AckDot, DRV_ACK, drvAckState, drvAckTitle } from "../DrvAck";
import { BoxFC, BoxFR } from "components/BoxCustom";
import DateTimePickerCustomTime from "components/DateTimePickerCustomTime";
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import { GlobalStateContext } from "contexts/GlobalStateContext";
import { jobOrderApiNm, jobOrderColNm } from "constants/jobOrderConstant";
import dayjs from "dayjs";
import { blueGrey, grey } from "@mui/material/colors";
import ComboBox from "components/ComboBox";
import { modifyPOICombo } from "branch/functions/modifyPOICombo";
import { suggessDrvCombo } from "utils/suggessDrvCombo";
import { ArticleRounded, EditRounded } from "resource/muiImport";
import EditContStsTmDialog from "../EditContStsTmDialog";
import PopoverSearchJobOrder from "components/PopoverSerachJobOrder/PopoverSearchJobOrder";

import LensIcon from '@mui/icons-material/Lens';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import { alertError } from "components/Alert";
import DailyJobDialogV3 from "../DailyJobDialogV3";



const shortDateProp = {
  inputFormat: "DD/MM HH:mm",
  mask: "__/__ __:__"
}


const getObjNm = (contStsId) => {
  const objNm = {
    poiNm: "",
    arvNm: "",
    LevNm: "",
    aptSt: "",
    aptEn: "",
    rtnSt: "",
    rtnEn: ""
  }
  if (contStsId === 1) {
    objNm.poiNm = "TakePOIId"
    objNm.arvNm = "TakeArvTm"
    objNm.LevNm = "TakeLevTm"
    objNm.aptSt = "TakeDteSt"
    objNm.aptEn = "TakeDteEn"
  } else if (contStsId === 2) {
    objNm.poiNm = "Sts2POIId"
    objNm.arvNm = ""
    objNm.LevNm = ""
    objNm.aptSt = ""
    objNm.aptEn = ""
  } else if (contStsId === 3) {
    objNm.poiNm = "LocPOIId"
    objNm.arvNm = "ArvTm"
    objNm.LevNm = "LevTm"
    objNm.aptSt = "AptTm"
  } else if (contStsId === 4) {
    objNm.poiNm = "Sts4POIId"
    objNm.arvNm = ""
    objNm.LevNm = ""
    objNm.aptSt = ""
    objNm.aptEn = ""
  } else if (contStsId === 5) {
    objNm.poiNm = "RtnPOIId"
    objNm.arvNm = "RtnArvTm"
    objNm.LevNm = "RtnLevTm"
    objNm.aptSt = "RtnDteSt"
    objNm.aptEn = "RtnDteEn"
  }
  return objNm
}

let initStsTm = dayjs()
let editContStsId = null
let swpJobOrdId = null

const ContStsComponent = ({ contStatusData, setContStsData, joData, setJOData }) => {

  const { ax, msData } = useContext(GlobalStateContext)
  const [dialogOpen, setDialogOpen] = useState(false)
  const [dialogSwpDailyJobOpen, setDialogSwpDailyJobOpen] = useState(false)

  const datePickerJobOrderProp = useCallback((name, isRequire) => ({
    label: jobOrderColNm[name],
    inputFormat: "DD/MM/YYYY HH:mm",
    mask: "__/__/____ __:__",
    value: joData[name],
    onChange: (newValue) => { setJOData(oldState => ({ ...oldState, [name]: newValue && newValue.format("YYYY-MM-DD HH:mm:00.00") })) },
    renderInput: (params) => <TextField size="small"  {...params} required={isRequire} sx={{ width: 140 }} />,
  }), [joData, setJOData])


  const handleIsCmptClick = useCallback((index) => (e) => {
    setContStsData(o => {
      const newData = o.map(cs => ({ ...cs }))
      const contStsData = newData[index];
      contStsData.IsCmpt = contStsData.IsCmpt === 1 ? 0 : 1
      return newData
    })
  }, [setContStsData])

  const handleDrvIdChange = useCallback((index) => (id) => {
    const tukId = msData.drivers.find(drv => drv.DrvId === id)?.TukId || null
    let stsTm = null
    setContStsData(oldData => {

      const newData = oldData.map(cs => ({ ...cs }))
      const contSts = newData[index];


      if (id) {
        if (joData) {
          if (contSts.ContStsId === 1) {
            stsTm = joData.TakeDteSt && dayjs(joData.TakeDteSt).isAfter(dayjs()) ? dayjs(joData.TakeDteSt) : dayjs()
          } else if (contSts.ContStsId === 3) {
            stsTm = joData.AptTm && dayjs(joData.AptTm).isAfter(dayjs()) ? dayjs(joData.AptTm) : dayjs()
          } else if (contSts.ContStsId === 5) {
            stsTm = joData.RtnDteSt && dayjs(joData.RtnDteSt).isAfter(dayjs()) ? dayjs(joData.RtnDteSt) : dayjs()
          } else {
            stsTm = dayjs()
          }
        } else {
          stsTm = dayjs()
        }
      }

      contSts.DrvId = id;
      contSts.StsTm = stsTm
      contSts.DispTm = dayjs()
      contSts.TukId = tukId
      return newData
    })
    setJOData(o => ({
      ...o,
      DrvId: id,
      DrvActTm: id === null ? null : dayjs(),
      TukId: tukId,
      processDrvId: id
    }))

  }, [msData.drivers, joData, setContStsData, setJOData])

  const handleEditStsTm = useCallback((contStsData) => () => {
    initStsTm = contStsData.StsTm ? dayjs(contStsData.StsTm) : dayjs()
    editContStsId = contStsData.ContStsId
    setDialogOpen(true)
  }, [])

  const handleChangeStsTm = useCallback((newValue) => {
    setContStsData(o => {
      const newData = o.map(cs => ({ ...cs }))
      const found = newData.find(cs => cs.ContStsId === editContStsId)
      found.StsTm = newValue;
      return newData
    })
  }, [setContStsData])

  const handleSelectJobOrder = useCallback((item) => {
    setJOData(o => ({ ...o, SwpJobOrdId: item?.JobOrdId, SwpContNo: item?.ContNo }))
  }, [setJOData])

  const handleSwpJobOrdIdOnBlur = useCallback((e) => {
    if (e.target.value) {
      ax.post(jobOrderApiNm.getContainerData, { JobOrdId: e.target.value }).then(value => {
        if (value.data) {
          setJOData(o => ({ ...o, SwpContNo: value.data.ContNo }))
        } else {
          setJOData(o => ({ ...o, SwpJobOrdId: "", SwpContNo: "" }))
          alertError(`ไม่พบเลขที่ใบงาน ${e.target.value}`)
        }
      })
    } else {
      setJOData(o => ({ ...o, SwpContNo: "" }))
    }
  }, [ax, setJOData])

  const handleSwpIconClick = useCallback((id) => () => {
    const found = contStatusData.find(cs => cs.ContStsId === 3)
    if (!found?.DrvId) {
      alertError("กรุณาเลือพนักงานขับรถส่งตู้ก่อนทำการสลับตู้")
      return
    }
    setJOData(o => ({
      ...o,
      [`SwpDrvIdSts${id}`]: o[`SwpDrvIdSts${id}`] ? null : found.DrvId
    }))
  }, [contStatusData, setJOData])

  const handleOpenDailyJobDialog = useCallback(() => {
    swpJobOrdId = joData.SwpJobOrdId
    setDialogSwpDailyJobOpen(true)
  }, [joData.SwpJobOrdId])
  return (
    <BoxFC sx={{ gap: 0.5 }}>
      {contStatusData.map((cs, index) => {
        let sDrvId = null
        for (let i = index - 1; i >= 0; i--) {
          if (contStatusData[i]?.DrvId) {
            sDrvId = contStatusData[i].DrvId
            break
          }
        }
        const objNm = getObjNm(cs.ContStsId)
        // 
        return (
          <BoxFC key={cs.ContStsId} >
            <BoxFR width="100%">
              <BoxFR sx={{
                border: `4px solid`, borderColor: `${cs.BgClr}.main`, borderRadius: 2
                , bgcolor: blueGrey[50], width: [2, 4].includes(cs.ContStsId) ? 600 : '100%'
              }} >
                <BoxFC width={130} height="100%" sx={{
                  gap: 0, p: 0.5, bgcolor: cs.DrvId ? `${cs.BgClr}.main` : blueGrey[50]
                  , alignItems: "center", justifyContent: "center", color: cs.DrvId ? "white" : "inherit"
                }}>
                  <BoxFR sx={{ gap: 0.5 }}>
                    <Typography >{cs.Name}</Typography>
                    {cs.DrvId === cs.AckDrvId && drvAckState(cs, msData, joData.FinDte) ?
                      <Tooltip title={drvAckTitle(cs.DrvAckTm)} arrow>
                        {drvAckState(cs, msData, joData.FinDte) === DRV_ACK.ACKED ?
                          <BoxFR sx={{ gap: 0.25 }}>
                            <CheckRounded fontSize="small" />
                            <Typography variant="body2">{dayjs(cs.DrvAckTm).format("HH:mm")}</Typography>
                          </BoxFR>
                          :
                          <BoxFR><AckDot /></BoxFR>
                        }
                      </Tooltip>
                      : null
                    }
                  </BoxFR>
                  <BoxFR>
                    <Typography>{cs.StsTm ? dayjs(cs.StsTm).format("DD/MM HH:mm") : "-"}</Typography>
                    {cs.DrvId ?
                      <IconButton sx={{ p: 0 }} onClick={handleEditStsTm(cs)}>
                        <EditRounded fontSize="small" sx={{ color: cs.DrvId ? "white" : "inherit" }} />
                      </IconButton>
                      : null
                    }
                  </BoxFR>

                </BoxFC>
                <ComboBox options={modifyPOICombo(msData.poiCombo, "TAKE", joData.Shipment?.ShpmTypId)}
                  sx={{ width: 150 }}
                  label={jobOrderColNm[objNm.poiNm]}
                  selectedId={joData[objNm.poiNm]}
                  setSelectedId={(id) => setJOData(o => ({ ...o, [objNm.poiNm]: id }))} />
                <ComboBox sx={{ width: 150 }} options={suggessDrvCombo(sDrvId, msData.driverCombo)} required={false}
                  selectedId={cs.DrvId}
                  label="พนักงานขับรถ"
                  setSelectedId={handleDrvIdChange(index)}
                />
                <ComboBox sx={{ width: 110 }} options={msData.truckCombo} required={false}
                  selectedId={cs.TukId}
                  label="เลขรถ"
                  setSelectedId={(id) => {
                    cs.TukId = id;
                    setContStsData(oldData => [...oldData])
                    setJOData(o => ({
                      ...o,
                      TukId: id
                    }))
                  }}
                />
                {[1, 3, 5].includes(cs.ContStsId) ?
                  <BoxFR>
                    <IconButton sx={{ p: 0.5, backgroundColor: "white" }} onClick={handleIsCmptClick(index)}
                      disabled={cs.DrvId ? false : true}>
                      <FactCheckRoundedIcon color={cs.IsCmpt === 1 ? "success" : "inherit"} />
                    </IconButton>

                    <DateTimePickerCustomTime {...datePickerJobOrderProp(objNm.arvNm, false)} {...shortDateProp} />
                    <DateTimePickerCustomTime {...datePickerJobOrderProp(objNm.LevNm, false)} {...shortDateProp} />
                    <DateTimePickerCustomTime {...datePickerJobOrderProp(objNm.aptSt, false)} {...shortDateProp} />
                    {cs.ContStsId !== 3 ?
                      <DateTimePickerCustomTime {...datePickerJobOrderProp(objNm.aptEn, false)} {...shortDateProp} />
                      : null
                    }

                  </BoxFR>
                  : null
                }
              </BoxFR>
              {cs.ContStsId === 4 ?
                <BoxFR sx={{
                  p: 1, position: "relative", border: `3px solid ${grey[500]}`
                  , borderColor: grey[500], bgcolor: grey[100], borderRadius: `4px`, flex: 1
                }} >
                  {/* <Typography variant="caption" position="absolute" top={-8} left={8} sx={{ bgcolor: "white", px: 0.5 }} >สลับตู้กลับ</Typography> */}
                  <BoxFC sx={{ gap: 0, alignItems: "center", px: 1 }}>
                    {/* <SwapHorizRounded sx={{ color: grey[600] }} /> */}
                    <Typography variant="body2">สลับกลับ</Typography>
                    <BoxFR >
                      {["4", "5"].map(id => (
                        <IconButton key={id} sx={{ p: 0 }} onClick={handleSwpIconClick(id)}>
                          {joData[`SwpDrvIdSts${id}`] ?
                            <LensIcon sx={{ color: `${msData.containerStatusObj[id].BgClr}.main` }} />
                            :
                            <PanoramaFishEyeIcon sx={{ color: `${msData.containerStatusObj[id].BgClr}.main` }} />
                          }
                        </IconButton>
                      ))}
                      {/* <CheckCircleRoundedIcon color={contSts.BgClr} />
                  :
                  <LensIcon color={contSts.BgClr} /> */}
                    </BoxFR>
                  </BoxFC>
                  <TextField size="small" label="เลขที่ใบงาน" sx={{ width: 150 }} type="number"
                    value={joData.SwpJobOrdId || ""} onChange={(e) => setJOData(o => ({ ...o, SwpJobOrdId: e.target.value }))}
                    onBlur={handleSwpJobOrdIdOnBlur}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">
                        <PopoverSearchJobOrder
                          handleSelectJobOrder={handleSelectJobOrder}
                          suggestDrvId={null}
                        />
                      </InputAdornment>,
                      endAdornment: <InputAdornment position="end">
                        <IconButton sx={{ p: 0 }} onClick={handleOpenDailyJobDialog}
                          disabled={!joData.SwpContNo}>
                          <ArticleRounded color={joData.SwpContNo ? "primary" : "disabled"} />
                        </IconButton>
                      </InputAdornment>
                    }} />
                  <TextField size="small" label="หมายเลขตู้" sx={{ width: 140 }} value={joData.SwpContNo || ""} />
                  <TextField size="small" label="ข้อมูลตู้ตัด" sx={{ flex: 1 }}
                    value={joData.SwpJobOrdIdPrev === null ? ""
                      : `${joData.SwpJobOrdIdPrev}:${joData.SwpContNoPrev}`} />
                </BoxFR>

                : null}
            </BoxFR>
          </BoxFC>
        )

      })}
      <DailyJobDialogV3
        selectedId={swpJobOrdId}
        dialogOpen={dialogSwpDailyJobOpen}
        setDialogOpen={setDialogSwpDailyJobOpen} />
      <EditContStsTmDialog
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        initValue={initStsTm}
        setContStsTm={handleChangeStsTm} />
    </BoxFC>
  )
}

export default React.memo(ContStsComponent);